import { pipe, map } from "rxjs"
import { Province } from "src/app/core/models/common/province.model"
import { ProvinciaDto } from "src/app/infrastructure/lobby-proxy/DTOs/provincia.dto"
import { regioneDtoToRegion } from "./region-dto.mapping"

export const mapProvinceDtoToProvince = pipe(
    map((source: ProvinciaDto) => provinceDtoToProvince(source))
)

export function provinceDtoToProvince(source: ProvinciaDto | null): Province | null {
    if (!source) return null
    return {
        id: source.provinciaId,
        name: source.nome,
        abbreviation: source.sigla,
        region: regioneDtoToRegion(source.regione)
    } as Province
}